import Typography from '@/components/Typography';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

/** Cards past this index are folded away on mobile until the reader opens them. */
export const MOBILE_VISIBLE_CARDS = 5;

/** Edge length of the square logo tile. Card height follows from it: 78 + 2 × 16 padding = 110. */
export const CARD_LOGO_SIZE = 78;

export const CardGrid = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing[16],

  [`${theme.mediaBreakpointUp.md}`]: {
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  },
}));

export const Card = styled.div<{ $foldedOnMobile?: boolean }>(({ theme, $foldedOnMobile }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
  padding: theme.spacing[16],
  borderRadius: theme.spacing[4],
  backgroundColor: theme.colors.highEmphasisWhite,
  boxShadow: theme.elevation[3],

  // Every card stays in the markup at every width — the mobile fold is presentation only, so a
  // crawler on a phone-shaped viewport still reads all ten entries.
  ...($foldedOnMobile ? { display: 'none' } : {}),

  [`${theme.mediaBreakpointUp.md}`]: {
    display: 'flex',
  },
}));

export const CardName = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
  type: 'span',
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  // Names run from "UPS" to "Spee-Dee Delivery"; wrapping keeps the long ones readable rather
  // than truncating away the part that identifies the carrier.
  minWidth: 0,
  overflowWrap: 'break-word',
}));

export const ViewMoreButton = styled.button(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[4],
  marginTop: theme.spacing[16],
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  color: theme.colors.blue,
  fontWeight: theme.fontWeight.semiBold,
  fontSize: theme.fontSizes[16],
  lineHeight: theme.lineHeight[16],
  letterSpacing: theme.letterSpacing[75],
  textTransform: 'uppercase',

  [`${theme.mediaBreakpointUp.md}`]: {
    display: 'none',
  },
}));

export const Chevron = styled.span<{ $isOpen?: boolean }>(({ $isOpen }) => ({
  display: 'inline-flex',
  transition: 'transform 0.15s ease',
  transform: $isOpen ? 'rotate(180deg)' : 'none',
}));
